import { render, staticRenderFns } from "./LostSalesList.vue?vue&type=template&id=72b52370&scoped=true&"
import script from "./LostSalesList.vue?vue&type=script&lang=js&"
export * from "./LostSalesList.vue?vue&type=script&lang=js&"
import style0 from "./LostSalesList.vue?vue&type=style&index=0&id=72b52370&lang=scss&scoped=true&"
import style1 from "./LostSalesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b52370",
  null
  
)

export default component.exports